module.exports = " <tr @click=select() _v-312ec324=\"\"> <td _v-312ec324=\"\"> <span class=brand _v-312ec324=\"\">{{ product.brand }}</span> <h4 _v-312ec324=\"\">{{ product.name }}</h4> <code _v-312ec324=\"\">{{ product.upc_13 }}</code> </td> <td class=price _v-312ec324=\"\"> {{ product.srp_amount | money }} / {{ product.unit_of_measure | unit-of-measure 1 true }} </td> </tr> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-312ec324!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 379
// module chunks = 2